<ngx-monaco-editor
  [options]="editorOptions"
  [ngModel]="model"
  (ngModelChange)="modelChange.emit($event)"
  class="p-inputtext"
  style="height: 100%"
></ngx-monaco-editor>
